"use client";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface PrismMarkdownProps {
    content: string;
    className?: string;
}

/** Full markdown renderer for Prism assistant messages. */
export function PrismMarkdown({ content, className = "" }: PrismMarkdownProps) {
    return (
        <div
            className={`prose prose-sm max-w-none text-ink-0 prose-p:my-2 prose-p:leading-relaxed prose-headings:font-serif prose-headings:text-ink-0 prose-strong:text-ink-0 prose-li:my-0.5 prose-a:text-accent prose-a:underline-offset-2 ${className}`}
        >
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
    );
}
